import { render, staticRenderFns } from "./PrestamoMaterialNew.vue?vue&type=template&id=2b2aedd4&scoped=true&"
import script from "./PrestamoMaterialNew.vue?vue&type=script&lang=ts&"
export * from "./PrestamoMaterialNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2aedd4",
  null
  
)

export default component.exports